import { render, staticRenderFns } from "./CoveredLegislations.vue?vue&type=template&id=cfb907d2&"
import script from "./CoveredLegislations.vue?vue&type=script&lang=js&"
export * from "./CoveredLegislations.vue?vue&type=script&lang=js&"
import style0 from "./CoveredLegislations.vue?vue&type=style&index=0&id=cfb907d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports